module.exports = __webpack_public_path__ + "static/img/banner.4574c9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner.png
// module id = wHlt
// module chunks = 1